import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

@doc.path('/plan_analyses/{id}/source')
export default class PlanAnalysisSourceModel extends MapServiceModel {
}
